import React, { Component } from "react";
import ReactDom from "react-dom";
import App from "./App";
import styles from "./styles/index.css";
import { BrowserRouter } from "react-router-dom";
ReactDom.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
